import { withInstall, withNoopInstall } from '@lit-element/utils'

import Descriptions from './src/description.vue'
import DescriptionsItem from './src/description-item'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtDescriptions: SFCWithInstall<typeof Descriptions> & {
  DescriptionsItem: typeof DescriptionsItem
} = withInstall(Descriptions, {
  DescriptionsItem,
})

export const LtDescriptionsItem: SFCWithInstall<typeof DescriptionsItem> =
  withNoopInstall(DescriptionsItem)

export default LtDescriptions

export * from './src/description'
export * from './src/description-item'
